module.exports = __webpack_public_path__ + "static/media/achievement-tier-3.31146435.svg";